import { useMutation } from 'react-query';
import {
    createMoovsecIntegrationAsync,
    deleteMoovsecIntegrationAsync,
    getMoovsecIntegrationByIdAsync,
    updateMoovsecIntegrationAsync,
} from '../../index';

export const useCreateMoovsecIntegrationAsync = () =>
    useMutation(createMoovsecIntegrationAsync);

export const useGetMoovsecIntegrationByIdAsync = () =>
    useMutation(getMoovsecIntegrationByIdAsync);

export const useUpdateMoovsecIntegrationAsync = () =>
    useMutation(updateMoovsecIntegrationAsync);

export const useDeleteMoovsecIntegrationAsync = () =>
    useMutation(deleteMoovsecIntegrationAsync);
